module.exports = __webpack_public_path__ + "img/耿艳娜.7747f2fb.jpg";